import * as THREE from "three"
import { useMemo, Suspense, useEffect, useRef, useState, useCallback } from "react"
import { Canvas, useFrame, useThree } from "@react-three/fiber"
import { Text, useAspect, Image, ScrollControls, Scroll, useScroll, Html, useVideoTexture, Ring } from "@react-three/drei"
import { EffectComposer, Bloom, Glitch } from "@react-three/postprocessing"
import { GlitchMode } from "postprocessing"

import { Flex, Box, useReflow } from "@react-three/flex"
import { useSpring, animated, config } from "@react-spring/three"

import BackGrid from "./components/BackGrid"
import Title from "./components/Title"
import LogoComponent from "./components/LogoComponent"
import Onboarding from "./components/Onboarding"
import ProgressIcons from "./components/ProgressIcons"
import QS from "./components/QS"
import Navbar from "./components/Navbar"
import Proyectos from "./components/Proyectos"
import Contacto from "./components/Contacto"
import TextComponent from "./components/TextComponent"
import  VideojuegosSection from "./components/VideojuegosSection"
// import useRefs from 'react-use-refs'

function Page({ currentSection, setCurrentSection }) {
  const [ScrolledDown, setScrolledDown] = useState(false)
  const [SelectedSection, setSelectedSection] = useState(0)
  const [BarNavigating, setBarNavigating] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [Init, setInit] = useState(false)

  // const titleRef1 = useRef();
  const titleRef2 = useRef()
  const titleRef3 = useRef()
  const scroll = useScroll()
  const group = useRef()
  const { size } = useThree()
  const [vpWidth, vpHeight] = useAspect(size.width, size.height)

  useEffect(() => {
    setInit(true)

    console.log("wpWidth", vpWidth)
    if (vpWidth < 4.5) {
      setIsMobile(true)
    }
  }, [])

  useFrame(() => {
    if (scroll.scroll.current < 0.025) {
      setCurrentSection(0)
    }
    if (scroll.scroll.current >= 0.025 && scroll.scroll.current < 0.49) {
      setCurrentSection(1)
    }
    if (scroll.scroll.current >= 0.49 && scroll.scroll.current < 0.83) {
      setCurrentSection(2)
    }
    if (scroll.scroll.current >= 0.83) {
      setCurrentSection(3)
    }
  })

  const resolvePosition = (idx) => {
    if (idx == 1) {
      return Init ? [-1, 0.5, 0] : [0, 0.5, 0]
    }

    return Init ? [1, 0.5, 0] : [0, 0.5, 0]
  }

  const { position1, position2, opacity } = useSpring({
    position1: resolvePosition(1),
    position2: resolvePosition(2),
    config: config.slow,
    opacity: Init ? 1 : 0,
  })

  const container = {
    display: "flex",
    overflow: "hidden",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100vw",
    height: "100vh",
  }

  const RingComponent = ({ xPos, zPos, txt, color, size, sizeTwo, opacity, position }) => {
    // return a ring that confronts the camera
    const { camera } = useThree()
    const ref = useRef()
    useFrame(() => {
      ref.current.lookAt(camera.position)
    })
    return (
      <animated.group ref={ref} position={position} opacity={0.1}>
        <Ring
          args={[size, sizeTwo, 90]}
          // position={[xPos, 0.5, zPos]}
          rotation={[0, 0, 0]}
          material-color={color}
          material-opacity={0.1}
          transparent>
          <TextComponent is3D txt={txt} weight={"light"} position={[-0,0,0]} opacity={opacity} />
          <meshStandardMaterial attach="material" side={THREE.DoubleSide} transparent opacity={opacity} />
        </Ring>
      </animated.group>
    )
  }

  const indicatorWidth = isMobile ? 0.65 : 2.6

  const texture = useVideoTexture("/plx-reaper.webm")

  return (
    <>
      <group position={[0, 1.1, 0.3]} >
        <Image position={[isMobile ? -0.44 : -2, 0, 0]} scale={[0.16, 0.22, 0]} url={"/logo.png"} transparent />
        {!isMobile && (
          <group position={[-0.6, 0, 0]}>
            <TextComponent rotation={[0, 0, 0]} position={[1.05, 0, 0]} fs={0.08} weight="bold" txt={"Q/S?"} id={"qs"} />
            <TextComponent rotation={[0, 0, 0]} position={[1.5, 0, 0]} fs={0.08} weight="bold" txt={"Proyectos"} id={"proyectos"} />
            <TextComponent rotation={[0, 0, 0]} position={[2, 0, 0]} fs={0.08} weight="bold" txt={"JUEGOS"} id={"juegos"} />
            <TextComponent rotation={[0, 0, 0]} position={[2.5, 0, 0]} fs={0.08} weight="bold" txt={"contacto"} id={"contacto"} />
          </group>
        )}
      </group>

      <group>
        <TextComponent rotation={[0, 0, 1.56]} position={[-indicatorWidth, 0.3, 0]} fs={isMobile ? 0.05 : 0.06} weight="light" txt={"1.0"} id={"1.0"} />
        <TextComponent rotation={[0, 0, 0]} position={[-indicatorWidth, 0.15, 0]} fs={isMobile ? 0.05 : 0.09} weight="light" txt={"|"} id={"1.0"} />
        <TextComponent rotation={[0, 0, 1.56]} position={[-indicatorWidth, -0, 0]} fs={isMobile ? 0.05 : 0.06} weight="light" txt={"2.0"} id={"2.0"} />
        <TextComponent rotation={[0, 0, 0]} position={[-indicatorWidth, -0.15, 0]} fs={isMobile ? 0.05 : 0.09} weight="light" txt={"|"} id={"1.0"} />
        <TextComponent rotation={[0, 0, 1.56]} position={[-indicatorWidth, -0.3, 0]} fs={isMobile ? 0.05 : 0.06} weight="light" txt={"3.0"} id={"3.0"} />
      </group>

      <group>
        <TextComponent rotation={[0, 0, -1.56]} position={[indicatorWidth, 0.3, 0]} fs={isMobile ? 0.05 : 0.06} weight="light" txt={"1.0"} id={"1.0"} />
        <TextComponent rotation={[0, 0, 0]} position={[indicatorWidth, 0.15, 0]} fs={isMobile ? 0.05 : 0.09} weight="light" txt={"|"} id={"1.0"} />
        <TextComponent rotation={[0, 0, -1.56]} position={[indicatorWidth, -0, 0]} fs={isMobile ? 0.05 : 0.06} weight="light" txt={"2.0"} id={"2.0"} />
        <TextComponent rotation={[0, 0, 0]} position={[indicatorWidth, -0.15, 0]} fs={isMobile ? 0.05 : 0.09} weight="light" txt={"|"} id={"1.0"} />
        <TextComponent rotation={[0, 0, -1.56]} position={[indicatorWidth, -0.3, 0]} fs={isMobile ? 0.05 : 0.06} weight="light" txt={"3.0"} id={"3.0"} />
      </group>

      <Scroll style={{ overflow: "hidden", position: "relative", height: "100%" }}>
        <RingComponent position={position1} xPos={-1} zPos={0} txt={"TECH"} size={0.5} sizeTwo={0.52} opacity={1} />
        <RingComponent position={[0,0.5,0]}  xPos={0} zPos={-0.1} txt={""} color={"grey"} size={1} sizeTwo={1.02} opacity={0.16} />
        <RingComponent position={position2} xPos={1} zPos={0} txt={"ARTE"} size={0.5} sizeTwo={0.52} opacity={1} />
        <group>
          <BackGrid zPos={-1} />
          <BackGrid zPos={isMobile ? -6.2 : -5.7} />

          <mesh position={[0, 2.5, -6]}>
            <meshBasicMaterial map={texture} toneMapped={false} transparent />
            <planeBufferGeometry args={[6.6, 5]} />
          </mesh>

          <group position={[0, -0.2, 1]}>
            <Image
              url={"/pxl(4).png"}
              scale={isMobile ? [0.22, 0.22, 0.22] : [0.36, 0.36, 0.36]}
              transparent
              position={[0, isMobile ? 0.05 : 0, 0]}
              zoom={0.9}
            />
            <Image
              url={"/rprz3.png"}
              scale={isMobile ? [0.4, 0.4, 0.4] : [0.6, 0.6, 0.6]}
              position={[isMobile ? -0.02 : -0.04, isMobile ? -0.14 : -0.25, 0]}
              transparent
              zoom={0.6}
            />
          </group>
        </group>
        {/* <HUD />
        {/* <div style={container}> */}

        <animated.group position={[0, -2.5, 0]}>
          {/* {currentSection == 1 && <QS scroll={scroll} />} */}
          <QS scroll={scroll} isMobile={isMobile} />
        </animated.group>
      
        <animated.group position={[0, -5.4, 0]}>
          {/* {currentSection == 2 && <Proyectos scroll={scroll} />} */}
          <Proyectos isMobile={isMobile} scroll={scroll} />
        </animated.group>
        <group position={[0, -8, 0]} >
          <VideojuegosSection isMobile={isMobile} />
        </group>
        <animated.group position={[0, -13, 0]}>
          <Contacto isMobile={isMobile} scroll={scroll} />
        </animated.group>
      </Scroll>
      <Effects currentSection={currentSection} />
    </>
  )
}

function Effects({ currentSection }) {
  return (
    <EffectComposer>
      <Glitch
        delay={currentSection > 0 ? [4, 4.4] : [2, 2.2]}
        duration={currentSection > 0 ? [0.3, 0.3] : [0.6, 0.8]}
        strength={currentSection > 0 ? [0.05, 0.05] : [0.2, 0.4]}
        // mode={GlitchMode.SPORADIC} // try CONSTANT_MILD
        // active={currentSection <= 0}
        ratio={0.1}
      />
    </EffectComposer>
  )
}

const navbarStyle = {
  position: "absolute",
  top: "0px",
  left: "0px",
  width: "100%",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 100,
}

export default function Landing() {
  const [CurrentSection, setCurrentSection] = useState(1)

  const centered = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: "100vh",
    width: "100vw",
  }

  return (
    <>
      <Suspense
        fallback={
          <div style={centered}>
            <img src="/init.gif" alt="loading" />
          </div>
        }>
        <Canvas
          gl={{ alpha: false }}
          camera={{ position: [0, 0, 2], zoom: 1 }}
          style={{
            scrollbarWidth: "none",
            position: "relative",
            height: "100vh",
            overflow: "hidden",
          }}>
          <ScrollControls
            pages={5.25} // Each page takes 100% of the height of the canvas
            distance={1} // A factor that increases scroll bar travel (default: 1)
            damping={4} // Friction, higher is faster (default: 4)
            horizontal={false} // Can also scroll horizontally (default: false)
            infinite={false} // C
            style={{ scrollbarWidth: "none" }}>
            <Page currentSection={CurrentSection} setCurrentSection={setCurrentSection} />
          </ScrollControls>
          <ambientLight intensity={0.5} />
        </Canvas>
      </Suspense>
    </>
  )
}
